import React from 'react';
import { Quote, Star } from 'lucide-react';
import { Reveal, RevealGroup, RevealItem } from './motion/Reveal';

// Sample reviews — replace with real client testimonials when available
const testimonials = [
  {
    quote: "Versatile Geopick verified the land I wanted to buy in Ibeju-Lekki and flagged an acquisition issue before I paid. That one search saved me millions.",
    name: "Adebayo O.",
    location: "Ibeju-Lekki, Lagos"
  },
  {
    quote: "Professional from start to finish. My survey plan was prepared, authenticated and delivered without me chasing anyone. Highly recommended.",
    name: "Chiamaka N.",
    location: "Ikeja, Lagos"
  },
  {
    quote: "As a first-time land buyer I was scared of fraud. Their team explained every step and handled the documentation. I now own my plot with confidence.",
    name: "Emeka T.",
    location: "Epe, Lagos"
  }
];

const Testimonials = () => (
  <section className="py-32 bg-white" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="text-center mb-20">
        <p className="text-emerald-700 font-medium tracking-wider uppercase text-sm mb-3">Client Stories</p>
        <h2 className="text-4xl md:text-5xl font-light text-stone-800 tracking-tight">
          Trusted by Land Buyers<br />Across Lagos
        </h2>
      </Reveal>

      <RevealGroup className="grid md:grid-cols-3 gap-8" stagger={0.15}>
        {testimonials.map((t, index) => (
          <RevealItem key={index}>
            <div
              data-testid={`testimonial-card-${index}`}
              className="h-full bg-stone-50 border border-stone-200 rounded-3xl p-10 flex flex-col hover:border-emerald-300 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6">
                <Quote className="h-6 w-6 text-emerald-700" />
              </div>
              <div className="flex gap-1 mb-5">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-lg text-stone-700 leading-relaxed flex-1">"{t.quote}"</p>
              <div className="mt-8 pt-6 border-t border-stone-200">
                <p className="font-medium text-stone-800">{t.name}</p>
                <p className="text-sm text-stone-500">{t.location}</p>
              </div>
            </div>
          </RevealItem>
        ))}
      </RevealGroup>
    </div>
  </section>
);

export default Testimonials;
